// App build version — bumped on every push to development/main, alongside
// the "version" field in package.json (kept in sync manually; CRA doesn't
// inject package.json's version into the build automatically).
//
// Format: MAJOR.MINOR.YYMMDD — the patch slot is the build date, so the
// version itself tells you when a build was pushed. If more than one push
// happens on the same day, bump MINOR instead of reusing the same date
// (e.g. 1.1.260818 -> 1.2.260818), so versions stay unique and increasing.
export const APP_VERSION = '1.4.261103';
